export default __webpack_public_path__ + "Src/Client/Assets/saveAssetCollectionNodeDialog.html";